<template>
    <v-dialog v-model="isActive" width="600" max-width="600">
        <v-card>
            <v-progress-linear v-if="loading" indeterminate height="5" color="primary"></v-progress-linear>
            <v-card-title class="text-center text-h5 black--text">Eliminar {{ tipo }}</v-card-title>
            <div class="d-flex justify-center">
                <v-icon color="primary" size="120">mdi-delete-alert-outline</v-icon>
            </div>
            <v-card-text class="text-center text-subtitle-1 d-flex justify-center black--text">
                <span v-html="mensaje"></span>
            </v-card-text>
            <v-card-text class="d-flex flex-column align-center justify-center">
                <v-btn @click="confirmAndClose(true)" dark class="pa-5 elevation-0" width="300"
                    color="primary">Eliminar</v-btn>
                <v-btn @click="confirmAndClose(false)" text color="primary" width="300"
                    class="mt-1 pa-5 elevation-0">Cancelar</v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    data() {
        return {
            isActive: false,
            callback: null,
        }
    },
    methods: {

        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.isActive = false
        },

        abrirDialogo() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            })
        },
    },
    props: {
        mensaje: {
            type: String,
            default: '¿Estás segura/o que deseas eliminar el elemento?'
        },
        tipo: {
            type: String,
            default: 'Item'
        },

    },

    //    props: ['tipo', 'item']
}

</script>